import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/Spinner";

interface ResearchButtonProps {
  isLoading: boolean;
  disabled: boolean;
  onClick: () => void;
}

export const ResearchButton = ({ isLoading, disabled, onClick }: ResearchButtonProps) => (
  <Button 
    onClick={onClick}
    disabled={disabled}
    className="w-full md:w-auto"
  >
    {isLoading ? (
      <>
        <Spinner size="sm" className="mr-2" ariaLabel="Researching" />
        Researching...
      </>
    ) : (
      'Research Fund'
    )}
  </Button>
);